import styled from "styled-components";

export const Container = styled.div`
  .hourRelationContainer {
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;
